import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ImageCroppedEvent } from "ngx-image-cropper";
import { Profile } from "oidc-client";
import { PlayerProfile, ProfileService } from "./profile.service";

@Component({
  selector: 'app-profile-component',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
  imageChangedEvent: any = '';
  public croppedImage: any = '';
  public shirtSize: string = 'Large';

  public constructor(private profileSvc: ProfileService, private router: Router) {
    this.getAvatar();
    this.getProfile();
  }

  public ngOnInit() { }
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    
  }
  imageLoaded(image: HTMLImageElement) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  public submit(evt: any) {
    evt.preventDefault();
    let x = this.croppedImage;
    this.profileSvc.saveAvatar(this.croppedImage).subscribe(
      (resp) => {
        this.router.navigate(['/home']);
      }
    )
  }

  public submitShirt(evt:any) {
    this.profileSvc.saveShirtSize(this.shirtSize).subscribe(
          (resp: any) => { console.log('shirt size saved'); },
          (err: any) => { console.error(err); alert('unknown shirt size') }
        );
  }

  public getAvatar() {
    this.profileSvc.getAvatar(null).subscribe(
      (resp: { base64img: string }) => { console.log('avatar is ', resp); this.croppedImage = resp.base64img; },
      (err: any) => { console.error(err) }
    );
  }
  public getProfile() {
    this.profileSvc.getProfile().subscribe(
      (p:PlayerProfile) => { 
        console.log('player profile is ', p);
        debugger;
      }
      ,
      (err:any) => {
        console.error(err);
      }
    )
  }
}
